import { ReduxStore } from "@interfaces/store";
import { IStoredItem, itemActions } from "@store/user/userItemsStore";
import {shallowEqual, useSelector} from "react-redux";
import {useGameServerAuto, useLoginServerAuto} from "@hooks/selectors/game.selectors";
import {useInventory} from "@hooks/selectors/user.selectors";
import {checkItemServers} from "../../../../helpers/utils";
import {useMemo} from "react";
import {useAppDispatch} from "@hooks/helperHooks";

export function useItem(id: string): IStoredItem {
    const dispatch = useAppDispatch();
    const item = useSelector(({ user: { items } }: ReduxStore) => items.find(i => i.id === id));

    if (!item && id) {
        dispatch(itemActions.loadItems([id]));
    }

    return item || {
        id,
        loaded: false,
        loading: true,
        error: null,
        name: '',
        servers: []
    };
}

export function useItems(ids: string[]): IStoredItem[] {
    const dispatch = useAppDispatch();
    const items = useSelector(({ user: { items } }: ReduxStore) => items.filter(item => ids.includes(item.id)), shallowEqual);

    if (items.length !== ids.length) {
        const existingIds = items.map(item => item.id);
        const toLoad = ids.filter(id => !existingIds.includes(id));
        
        if(toLoad.length > 0) {
            dispatch(itemActions.loadItems(toLoad));
        }

        items.concat(toLoad.map(id => {
            return {
                id,
                loaded: false,
                loading: true,
                error: null,
                name: '',
                servers: []
            }
        }))
    }

    return items;
}

export function useFilteredInventory(filterByLogin?: boolean, filterByGame?: boolean, defaultServerId?: string) {
    const login = useLoginServerAuto();
    const game = useGameServerAuto();

    const items = useInventory();
    return useMemo(() => items.filter(item => {
        if(!filterByGame && !filterByLogin) return true;

        if (filterByLogin && !checkItemServers(item, login?.id || defaultServerId)) return false;
        if (filterByGame && !checkItemServers(item, game?.id || defaultServerId)) return false;

        return true;
    }), [filterByGame, filterByLogin, items, game?.id, login?.id, defaultServerId]);
}